import { SUBSCRIPTION_PLAN, type SubscriptionPlan } from 'src/data/subscription';
import { trackCrmEvent as mutationTrackCrmEvent } from 'src/graphql/event';
import { captureMessage } from 'src/lib/sentry';

export const CRM_EVENT = {
  clickedUpgradeButton: 'clicked_upgrade_button',
};
type CrmEvent = (typeof CRM_EVENT)[keyof typeof CRM_EVENT];

export const CRM_SUBSCRIPTION_ACTION = {
  buyNow: 'buy_now',
  bookDemo: 'book_a_demo',
  requestDemo: 'request_a_demo',
};

const CRM_SUBSCRIPTION_PLAN_VALUE = {
  basic: 'basic',
  starter: 'starter',
  dataDriven: 'data_driven',
  businessSelfServe: 'business_self_serve',
  business: 'business',
  enterprise: 'enterprise',

  // Not used anymore values
  /*
  acquisition: 'acquisition',
  conversion: 'conversion',
  engagement: 'engagement',
  */
};
type CrmSubscriptionPlan =
  (typeof CRM_SUBSCRIPTION_PLAN_VALUE)[keyof typeof CRM_SUBSCRIPTION_PLAN_VALUE];

export const trackCrmEvent = (eventName: CrmEvent, attributes: object) => {
  mutationTrackCrmEvent(eventName, attributes).catch((error: Error) => {
    captureMessage('Error tracking CRM event', {
      level: 'warning',
      extra: {
        error: error.toString(),
        source: 'lib/events/crm -> trackCrmEvent',
        eventName,
        attributes,
      },
    });
  });
};

export const convertSubscriptionPlanForCrm = (
  plan: SubscriptionPlan
): CrmSubscriptionPlan | SubscriptionPlan => {
  switch (plan) {
    case SUBSCRIPTION_PLAN.basic:
      return CRM_SUBSCRIPTION_PLAN_VALUE.basic;

    case SUBSCRIPTION_PLAN.starter:
    case SUBSCRIPTION_PLAN.starterLegacy:
      return CRM_SUBSCRIPTION_PLAN_VALUE.starter;

    case SUBSCRIPTION_PLAN.dataDriven:
    case SUBSCRIPTION_PLAN.ddTeamsLegacy:
      return CRM_SUBSCRIPTION_PLAN_VALUE.dataDriven;

    case SUBSCRIPTION_PLAN.businessSelfServeLegacy:
      return CRM_SUBSCRIPTION_PLAN_VALUE.businessSelfServe;

    case SUBSCRIPTION_PLAN.business:
    case SUBSCRIPTION_PLAN.businessPlus:
    case SUBSCRIPTION_PLAN.businessMax:
    case SUBSCRIPTION_PLAN.proPublisherLegacy:
      return CRM_SUBSCRIPTION_PLAN_VALUE.business;

    case SUBSCRIPTION_PLAN.performance:
    case SUBSCRIPTION_PLAN.performancePlus:
    case SUBSCRIPTION_PLAN.performanceMax:
    case SUBSCRIPTION_PLAN.enterpriseLegacy:
      return CRM_SUBSCRIPTION_PLAN_VALUE.enterprise;

    default:
      return plan;
  }
};
